module.exports = __webpack_public_path__ + "fonts/ralewaybold.be22592.woff";